/**
 * Session Activity Types
 */
export type TSessionActivityTypeName = string;

export enum SessionActivityType {
  AFMRecordingSession = 'AFM Recording Session',
  WorkTime = 'Work Time',
  WorkTimeNight = 'Work Time - Night (+10%)',
  WorkTimeLateNight = 'Work Time - Late Night (+20%)', // extras only
  WorkTimeSaturday = 'Work Time - Saturday',
  WorkTimeSunday = 'Work Time - Sunday',
  WorkTimeHoliday = 'Work Time - Holiday',
  MealBreakfast = 'Meal - Breakfast',
  MealLunch = 'Meal - Lunch',
  MealDinner = 'Meal - Dinner',
  Fitting = 'Fitting',
  WardrobeChange = 'Wardrobe Change',
  HairAndMakeup = 'Hair And Makeup',
  TravelToLocation = 'Travel To Location',
  TravelToLocationAfterMidnight = 'Travel To Location (After Midnight)',
  TravelFromLocation = 'Travel From Location',
  TravelFromLocationAfterMidnight = 'Travel From Location (After Midnight)',
  Audition = 'Audition',
  Rehearsal = 'Rehearsal',
  LineMemorization = 'Line Memorization',
  AuditionScratchTrack = 'Audition Scratch Track',
  RecordingSession = 'Recording Session',
  VoiceOver = 'Voice Over',
  Demo = 'Demo',
  CreativeSession = 'Creative Session',
  CreativeAudition = 'Creative Audition',
}

export const sessionActivityTypeTitles: Record<string, string> = {
  [SessionActivityType.WorkTime]: 'Work Session',
  [SessionActivityType.Fitting]: 'Fitting Session',
  [SessionActivityType.TravelToLocation]: 'Travel Session - To Location',
  [SessionActivityType.TravelFromLocation]: 'Travel Session - From Location',
  [SessionActivityType.MealBreakfast]: 'Breakfast',
  [SessionActivityType.MealLunch]: 'Lunch',
  [SessionActivityType.MealDinner]: 'Dinner',
  [SessionActivityType.Audition]: 'Audition',
  [SessionActivityType.LineMemorization]: 'Line Memorization',
  [SessionActivityType.AuditionScratchTrack]: 'Audition Scratch Track',
  [SessionActivityType.Demo]: 'Demo',
  [SessionActivityType.VoiceOver]: 'Voice Over',
  [SessionActivityType.CreativeSession]: 'Creative Session',
  [SessionActivityType.CreativeAudition]: 'Creative Audition',
};

export const TravelActivityTypes = new Set([
  SessionActivityType.TravelToLocation,
  SessionActivityType.TravelToLocationAfterMidnight,
  SessionActivityType.TravelFromLocation,
  SessionActivityType.TravelFromLocationAfterMidnight,
]);

export const MealActivityTypes = new Set([
  SessionActivityType.MealBreakfast,
  SessionActivityType.MealLunch,
  SessionActivityType.MealDinner,
]);

export const WorkActivityTypes = new Set([
  SessionActivityType.WorkTime,
  SessionActivityType.WorkTimeNight,
  SessionActivityType.WorkTimeLateNight,
  SessionActivityType.WorkTimeSaturday,
  SessionActivityType.WorkTimeSunday,
  SessionActivityType.WorkTimeHoliday,
  SessionActivityType.Fitting,
  SessionActivityType.HairAndMakeup,
  SessionActivityType.Audition,
  SessionActivityType.Rehearsal,
  SessionActivityType.RecordingSession,
  SessionActivityType.VoiceOver,
  SessionActivityType.AuditionScratchTrack,
  SessionActivityType.Demo,
  SessionActivityType.CreativeSession,
  SessionActivityType.CreativeAudition,
]);

export const AuditionActivityTypes = new Set([
  SessionActivityType.Audition,
  SessionActivityType.AuditionScratchTrack,
  SessionActivityType.CreativeAudition,
]);

/**
 * Session Activity Time of Day
 */
export enum SessionActivityTimeOfDay {
  Night = 'night',
  LateNight = 'late-night',
  AfterMidnight = 'after-midnight',
}

/**
 * Work Time Types
 */
export enum WorkTimeType {
  // OnCamera = 'On Camera',
  // OffCamera = 'Off Camera',
  // Overtime = 'Overtime',
  StraightTime = 'Straight Time',
  TimeAndOneHalf = 'Time And One Half',
  DoubleTime = 'Double Time',
  NoServiceDay = 'No Service Day',
  NoServiceDayWeekendHoliday = 'No Service Day (Weekend/Holiday)',
}
